import { useTranslation } from 'react-i18next'
import Button from '../Buttons/Button'

interface Props {
  onExit: () => void
  onGoToLogin: () => void
}

/**
 * Shown after a manual bank transfer checkout, telling the user that payment
 * instructions were emailed to the registered company address.
 */
const BankTransferSentModal = ({ onExit, onGoToLogin }: Props) => {
  const { t } = useTranslation()

  return (
    <div className='overflow-y-auto overflow-x-hidden fixed right-0 left-0 top-0 z-50 flex justify-center items-center md:inset-0 h-full bg-[rgba(0,0,0,0.5)]'>
      <div className='relative px-4 w-full h-auto max-w-2xl'>
        <div className='bg-white rounded-20px shadow p-7 sm:p-10 text-center'>
          <h3 className='text-xl sm:text-2xl font-bold text-black'>
            {t('bankTransferSentTitle')}
          </h3>

          <p className='mt-5 text-base text-[#3D3D3D]'>
            {t('bankTransferSentDescription')}
          </p>

          <div className='mt-7 flex items-center justify-center gap-4 flex-wrap'>
            <Button
              type='button'
              text={t('exit')}
              width='w-max'
              bgColor='bg-[#E1ECFC]'
              textColor='text-black'
              onClickHandler={onExit}
            />
            <Button
              type='button'
              text={t('goToLogin')}
              width='w-max'
              onClickHandler={onGoToLogin}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BankTransferSentModal
